export enum ErrorCodes {
  cantVerify = "400000",
  invalidDomain = "400001",
}
